import React from 'react';
import {Dummy} from '../'
import styles from './style.css'

export default class Valve extends Dummy {

    paintCanvas(cvs) {
        var canvas = document.getElementById(cvs);
        if (canvas.getContext) {
            var ctx = canvas.getContext('2d');


            ctx.beginPath();
            ctx.moveTo(10, 25);
            ctx.lineTo(10, 10);
            ctx.lineTo(19, 10);
            ctx.stroke();
            ctx.closePath();

            ctx.beginPath();
            ctx.arc(11, 35, 10, 0, Math.PI * 2, true);
            ctx.stroke();
            ctx.closePath();


        }
    };

    render() {
        return (
            <div className={styles.caption} id={this.props.div_id}>
                {this.props.caption}<br/>
                <canvas className='cvs' id={this.props.canvas_id} width="26" height="46"/>
            </div>
        );
    }
}

Valve.propTypes = {
    canvas_id: React.PropTypes.string,
    div_id: React.PropTypes.string,
    caption: React.PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/components/entries/Valve/index.jsx